import React, { Fragment, useEffect, useState } from 'react';
import { Col, Row, Card } from 'react-bootstrap';

import { useChat } from '@/Hooks/UseChat';
import useTranslation from '@/Hooks/UseTranslation';

import ContentHeader from '@/Layouts/MainLayout/components/ContentHeader';
import ContentBody from '@/Layouts/MainLayout/components/ContentBody';

import ChatSidebar from '@/Components/ChatComponents/ChatSidebar/ChatSidebar';
import ChatContent from '@/Components/ChatComponents/ChatContent/ChatContent';

import './ChatPage.scss'
import MainLayout from '@/Layouts/MainLayout/MainLayout';

const ChatPage: React.FC = (props: any) => {

  const { t } = useTranslation();

  const {
    chat_id
  } = props.match.params

  const { joinChat, currentChat, messages, sendMessage, unsetCurrentChat } = useChat();

  const [ windowWidth, setWindowWidth ] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {

    if (!chat_id) {

      unsetCurrentChat()
    } else if (!currentChat) {

      joinChat([ '', chat_id ]);
    }
  }, [ chat_id ])

  const focusConversationSearch = () => {
    document.getElementById('chat-conversation-search')?.focus()
  }

  return (
    <MainLayout className="pl4-chat-layout" menuName="chat" subMenuName="chat">
      <ContentHeader
        title={t('CHAT:Title')}
        subtitle="Centro de colaboración del proyecto"
      >
        {currentChat && (
          <div className='ul-widget__head-toolbar d-block d-lg-none'>
            <button className="btn btn-secondary" onClick={() => unsetCurrentChat()}>
              <i className="fas fa-fw fa-bars"></i>
            </button>
          </div>
        )}
      </ContentHeader>
      <ContentBody noScroll>
        <Row className="chat-workspace-row">
          {windowWidth < 992 && (
            <Fragment>
              {!currentChat && (
                <Col className='chat-workspace-col'>
                  <Card className='chat-card chat-card-sidebar'>
                    <ChatSidebar />
                  </Card>
                </Col>
              )}
              {currentChat && (
                <Col className='chat-workspace-col'>
                  <Card className='chat-card chat-card-content'>
                    <ChatContent
                      project
                      chat={currentChat}
                      messages={messages}
                      onSendMessage={(message) => sendMessage(message)}
                      onStartConversation={focusConversationSearch}
                      disabled={false}
                    />
                  </Card>
                </Col>
              )}
            </Fragment>
          )}
          {windowWidth >= 992 && (
            <Fragment>
              <Col lg={4} xl={3} className='chat-workspace-col chat-workspace-sidebar-col'>
                <Card className='chat-card chat-card-sidebar'>
                  <ChatSidebar />
                </Card>
              </Col>
              <Col lg={8} xl={9} className='chat-workspace-col'>
                <Card className='chat-card chat-card-content'>
                  <ChatContent
                    project
                    chat={currentChat}
                    messages={messages}
                    onSendMessage={(message) => sendMessage(message)}
                    onStartConversation={focusConversationSearch}
                    disabled={false}
                  />
                </Card>
              </Col>
            </Fragment>
          )}
        </Row>
      </ContentBody>

      {/* <Modal
        className='modal-chat-sidebar'
        show={windowWidth < 992 && (showModal || !currentChat)}
        onHide={closeChatModal}
      >
        <div style={{ height: '100%' }}>
          <ChatSidebar onSelectChat={() => closeChatModal()} />
        </div>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            <span className="icon-cancelar"></span> {t('CHAT:ChatModalCloseButton')}
          </button>
        </Modal.Footer>
      </Modal> */}
    </MainLayout>
  );
};

export default ChatPage;
